"use strict"; // Sh**t! I Smoke
// Copyright (C) 2018-2020  Marcelo S. Coelho, Amaury Martiny

exports.__esModule = true;
exports.round = void 0;
/**
 * Round a number to 1 decimal. Useful for showing cigarettes on the home page.
 *
 * @param n - The number to round;
 */

function round(n) {
  return Math.round(n * 10) / 10;
}

exports.round = round;